module.exports = __webpack_public_path__ + "img/fechar.7e514ff9.svg";